import { render, staticRenderFns } from "./FindCustomer.vue?vue&type=template&id=2083a0dc"
import script from "./FindCustomer.vue?vue&type=script&lang=js"
export * from "./FindCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports